import React from 'react'
import { Link } from 'react-router-dom';
import { MenuInformasiLainnya, MenuInformasi, MenuProfile, MenuAduan } from '../../master-data/menu';
import { FiChevronDown } from "react-icons/fi";

export const HeaderMenu = () => {

    function getCurrentDate() {
        var today = new Date();
        return today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds() + ' PM'
    }

    return (
        <ul id="mainmenu" className="jl_main_menu">
            
            <li className="menu-item current-menu-item current_page_item">
                <Link to={'/home'}>
                    Home
                    <span className="border-menu" />
                </Link>
            </li>
            <li className="menu-item menu-item-has-children">
                <a href="#void">
                    Profil
                    <span className="border-menu" />
                    <FiChevronDown className='navbar-head-icon' />
                </a>
                <ul className="sub-menu">
                    {
                        MenuProfile && MenuProfile.map((item, index) => {
                            return (
                                <li key={index} className="menu-item">
                                    <Link to={item.link}>
                                        {item.name}
                                        <span className="border-menu" />
                                    </Link>
                                </li>
                            )
                        })
                    }
                </ul>
            </li>

            <li className="menu-item menu-item-has-children">
                <a href="#void">
                    Informasi
                    <span className="border-menu" />
                    <FiChevronDown className='navbar-head-icon' />
                </a>
                <ul className="sub-menu menu_post_feature jl_menu_tls">
                <li>
                    <div id="sprasa_recent_large_widgets-2" className="widget main_post_style">
                    <h3 className="widget-title"><span>Recent Posts</span></h3>
                        <div className="jl_grid_overlay jl_w_menu jl_clear_at">
                            
                            {
                                MenuInformasi && MenuInformasi.map((item, index) => {
                                    return (
                                        <div key={index} className="jl_grid_overlay_col">
                                            <div className="jl_grid_verlay_wrap jl_radus_e">
                                                <div className="jl_f_img_bg" style={{backgroundImage: 'url("'+ item.image +'")'}} ></div>
                                                    <Link to={item.link} className="jl_f_img_link" ></Link> 
                                                    <span className="jl_f_cat">
                                                        <Link className="post-category-color-text" style={{background: '#91bd3a'}} to={item.link}>Informasi {parseInt(index) + 1}</Link>
                                                    </span>
                                                    <div className="jl_f_postbox">
                                                        <h3 className="jl_f_title"><Link to={item.link}>{item.name}</Link></h3>
                                                        <span className="jl_post_meta">
                                                            <span className="post-date">
                                                                <i className="jli-pen" />Diperbarui: {getCurrentDate()}
                                                            </span>
                                                        </span>
                                                    </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        
                        </div>
                    </div>
                </li>
                </ul>
                {/* <ul className="sub-menu">
                    {
                        MenuInformasi && MenuInformasi.map((item, index) => {
                            return (
                                <li className="menu-item">
                                    <Link to={item.link}>
                                        {item.name}
                                        <span className="border-menu" />
                                    </Link>
                                </li>
                            )
                        })
                    }
                </ul> */}
            </li>

            <li className="menu-item menu-item-has-children">
                <a href="#void">
                    Informasi Lainnya
                    <span className="border-menu" />
                    <FiChevronDown className='navbar-head-icon' />
                </a>
                <ul className="sub-menu">
                    {
                        MenuInformasiLainnya && MenuInformasiLainnya.map((item, index) => {
                            return (
                                <li key={index} className="menu-item">
                                    <Link to={item.link}>
                                        {item.name}
                                        <span className="border-menu" />
                                    </Link>
                                </li>
                            )
                        })
                    }
                </ul>
            </li>

            <li className="menu-item current-menu-item current_page_item">
                <Link to={'/infografis'}>
                    Infografis
                    <span className="border-menu" />
                </Link>
            </li>

            <li className="menu-item current-menu-item current_page_item">
                <Link to={'/download'}>
                    Download
                    <span className="border-menu" />
                </Link>
            </li>

            <li className="menu-item menu-item-has-children">
                <a href="#void">
                    Aduan
                    <span className="border-menu" />
                    <FiChevronDown className='navbar-head-icon' />
                </a>
                <ul className="sub-menu">
                    {
                        MenuAduan && MenuAduan.map((item, index) => {
                            return (
                                <li key={index} className="menu-item">
                                    <Link to={item.link}>
                                        {item.name}
                                        <span className="border-menu" />
                                    </Link>
                                </li>
                            )
                        })
                    }
                </ul>
            </li>

            <li className="menu-item current-menu-item current_page_item">
                <Link to={'/kritik-dan-saran'}>
                    Kritik dan Saran
                    <span className="border-menu" />
                </Link>
            </li>
            <li className="menu-item current-menu-item current_page_item">
                <Link to={'/survey-kepuasan-masyarakat'}>
                    Survey
                    <span className="border-menu" />
                </Link>
            </li>
        </ul>
    )
};